import { Button } from "antd";

/**
 * Every button in the app. Size, radius and weight come from the antd
 * theme — the old hardcoded #1976D2 loading state has gone, so a busy
 * button now keeps whatever type it was declared with.
 */
const BaseButton = (props) => {
  const { state, children, ...rest } = props;

  if (state) {
    return (
      <Button { ...rest } loading disabled>
        Working…
      </Button>
    );
  }

  return <Button { ...rest }>{ children }</Button>;
};

export default BaseButton;
